/**
 * TestcaseResults component is responsible for displaying the details of
 * test cases for a student's programming submission. It uses the access control
 * variables to determine whether the test cases should be shown to the student
 * */

import React from "react";
import Testcase from "../Testcase/Testcase";
import "./testcase_details_student.styles.scss";

export default function TestcaseResults({
  programId,
  access,
  testResults,
  testcasesExportHandler,
}) {
  return (
    //show Testcase details component by following access control
    <div>
      {access?.enable_display_visible_testcases ||
      access?.enable_display_hidden_testcases ? (
        <>
          {testResults?.length > 0 ? (
            <Testcase
              testResults={testResults}
              testcasesExportHandler={testcasesExportHandler}
            />
          ) : null}
        </>
      ) : null}
    </div>
  );
}
